export interface User {
  id: string;
  display_name: string;
  joined_at: string;
}

export interface Room {
  id: string;
  name: string;
  creator_id: string;
  participants: { [key: string]: User };
  deck_type: DeckType;
  created_at: string;
  active_session?: VotingSession;
  session_history: VotingSession[];
  team_id?: string;
  story_queue?: QueueItem[];
}

/** A story waiting to become the next voting session. */
export interface QueueItem {
  id: string;
  title: string;
  description?: string;
  jira_key?: string;
}

export interface VotingSession {
  id: string;
  room_id: string;
  story_title: string;
  story_description?: string;
  votes: { [key: string]: Vote };
  is_revealed: boolean;
  created_at: string;
  finished_at?: string;
}

export interface Vote {
  user_id: string;
  value: string;
  voted_at: string;
}

export type DeckType = 'fibonacci' | 'powers_of_2' | 'tshirt';

export interface CreateRoomRequest {
  name: string;
  display_name: string;
  deck_type?: DeckType;
  team_id?: string;
}

export interface JoinRoomRequest {
  display_name: string;
}

export interface CreateVotingSessionRequest {
  story_title: string;
  story_description?: string;
}

export interface CastVoteRequest {
  user_id: string;
  value: string;
}

export const DECK_CARDS = {
  fibonacci: ['0', '1', '2', '3', '5', '8', '13', '21', '?'],
  powers_of_2: ['1', '2', '4', '8', '16', '32', '64', '128', '?'],
  tshirt: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '?'],
} as const;